import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { orderActionTypes } from '../order-action-types';
import { IOrderAction } from '../order-interfaces';
import * as React from 'react';

export const fetchPartnerCommissions = async (dispatch: React.Dispatch<IOrderAction>): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.SET_PARTNERS_COMMISSIONS_LOADING, payload: true });
		const res = await axios.get(`${BASE_URL.ORDERS}/Commissions`);
		dispatch({ type: orderActionTypes.FETCH_PARTNERS_COMMISSIONS, payload: res?.data ?? [] });
	} catch (e) {
		console.log('fetchPartnerCommissions error', e);
		dispatch({ type: orderActionTypes.SET_PARTNERS_COMMISSIONS_LOADING, payload: false });
	}
};

export const fetchPartnerCommissionsById = async (dispatch: React.Dispatch<IOrderAction>, pid: string): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.SET_PARTNERS_COMMISSIONS_BY_ID_LOADING, payload: true });
		const res = await axios.get(`${BASE_URL.ORDERS}/Commissions/${pid}`);
		dispatch({ type: orderActionTypes.FETCH_PARTNERS_COMMISSIONS_BY_ID, payload: res?.data });
	} catch (e) {
		console.log('fetchPartnerCommissionsDetails error', e);
		dispatch({ type: orderActionTypes.SET_PARTNERS_COMMISSIONS_BY_ID_LOADING, payload: false });
	}
};

export const fetchPartnerCommissionsDetails = async (dispatch: React.Dispatch<IOrderAction>, pid: string): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.SET_PARTNERS_COMMISSIONS_DETAILS_LOADING, payload: true });
		const res = await axios.get(`${BASE_URL.ORDERS}/Commissions/${pid}/details`);
		dispatch({ type: orderActionTypes.FETCH_PARTNERS_COMMISSIONS_DETAILS, payload: res?.data ?? [] });
	} catch (e) {
		console.log('fetchPartnerCommissionsDetails error', e);
		dispatch({ type: orderActionTypes.SET_PARTNERS_COMMISSIONS_DETAILS_LOADING, payload: false });
	}
};
export const fetchAgenciesCommissions = async (dispatch: React.Dispatch<IOrderAction>): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.SET_AGENCIES_COMMISSIONS_LOADING, payload: true });
		const res = await axios.get(`${BASE_URL.ORDERS}/Commissions`);
		dispatch({ type: orderActionTypes.FETCH_AGENCIES_COMMISSIONS, payload: res?.data ?? [] });
	} catch (e) {
		console.log('fetchAgenciesCommissions error', e);
		dispatch({ type: orderActionTypes.SET_AGENCIES_COMMISSIONS_LOADING, payload: false });
	}
};

export const fetchAgenciesCommissionsById = async (dispatch: React.Dispatch<IOrderAction>, id: string): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.SET_AGENCIES_COMMISSIONS_BY_ID_LOADING, payload: true });
		const res = await axios.get(`${BASE_URL.ORDERS}/Commissions/${id}`);
		dispatch({ type: orderActionTypes.FETCH_AGENCIES_COMMISSIONS_BY_ID, payload: res?.data ?? [] });
	} catch (e) {
		console.log('fetchAgenciesCommissionsDetails error', e);
		dispatch({ type: orderActionTypes.SET_AGENCIES_COMMISSIONS_BY_ID_LOADING, payload: false });
	}
};

export const fetchAgenciesCommissionsDetails = async (dispatch: React.Dispatch<IOrderAction>, pid: string): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.SET_AGENCIES_COMMISSIONS_DETAILS_LOADING, payload: true });
		const res = await axios.get(`${BASE_URL.ORDERS}/Commissions/${pid}/details`);
		dispatch({ type: orderActionTypes.FETCH_AGENCIES_COMMISSIONS_DETAILS, payload: res?.data ?? [] });
	} catch (e) {
		console.log('fetchAgenciesCommissionsDetails error', e);
		dispatch({ type: orderActionTypes.SET_AGENCIES_COMMISSIONS_DETAILS_LOADING, payload: false });
	}
};

export const postCommissions = async (id: string): Promise<void> => {
	await axios.post(`${BASE_URL.ORDERS}/Commissions/${id}/post`);
};